import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import AuditTable from '@/components/Audit/AuditTable.vue';
import useAppMixin from '@/mixins/appMixin';


export default /*#__PURE__*/_defineComponent({
  __name: 'Audit',
  setup(__props) {

const { setPageTitle } = useAppMixin();
setPageTitle('PageTitle.Audit.Default');

return (_ctx: any,_cache: any) => {
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, { fluid: "" }, {
    default: _withCtx(() => [
      _createVNode(AuditTable)
    ]),
    _: 1
  }))
}
}

})